import React from 'react';
import { motion } from 'framer-motion';
import { healthIcons } from './icons';

interface VitalMetricProps {
  metric: {
    name: string;
    value: string;
    unit: string;
    iconName: string;
    status: 'normal' | 'warning';
    trend?: 'up' | 'down' | 'stable';
    range?: string;
  };
}

export function VitalMetrics({ metric }: VitalMetricProps) {
  const Icon = healthIcons[metric.iconName];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-muted/30 p-4 rounded-lg"
    >
      <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
        <Icon className="w-4 h-4" />
        <span>{metric.name}</span>
      </div>
      
      <div className="flex items-baseline gap-2">
        <div className={`text-2xl font-bold ${
          metric.status === 'normal' ? "text-success" : "text-warning"
        }`}>
          {metric.value}
        </div>
        <div className="text-sm text-muted-foreground">{metric.unit}</div>
      </div>

      {metric.range && (
        <div className={`text-xs mt-1 ${
          metric.status === 'normal' ? "text-success" : "text-warning"
        }`}>
          {metric.status === 'normal' ? 'Within range' : `Range: ${metric.range}`}
        </div>
      )}
    </motion.div>
  );
}